import { render, staticRenderFns } from "./GoodBye.vue?vue&type=template&id=60f161cf&lang=html&"
import script from "./GoodBye.vue?vue&type=script&lang=js&"
export * from "./GoodBye.vue?vue&type=script&lang=js&"
import style0 from "./GoodBye.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports